import { getCartDisplayedData } from '../helpers/cart';
import { REQUEST_STATUS } from '../constants';

export const initialState = {
  status: REQUEST_STATUS.IDLE,
  acknowledgeNotification: false
};

const rrpCartReducer = (state = initialState, action) => {
  if (action.type === `RRP_SHOPPING_CART_LOADING`) {
    return {
      ...state,
      loading: true,
      error: false,
      status: REQUEST_STATUS.PENDING
    };
  }

  if (action.type === `RRP_SHOPPING_CART_SUCCESS`) {
    return {
      ...state,
      rrpOrder: action.value,
      loading: false,
      error: false,
      status: REQUEST_STATUS.SUCCEEDED
    };
  }

  if (action.type === `RRP_SHOPPING_CART_ERROR`) {
    return {
      ...state,
      rrpOrder: null,
      loading: false,
      error: true,
      status: REQUEST_STATUS.FAILED
    };
  }

  if (action.type === `RRP_ADD_MASTER_ORDER_LOADING`) {
    return {
      ...state,
      loading: true,
      error: false,
      addedItems: null,
      removedItems: null
    };
  }

  if (action.type === `RRP_ADD_MASTER_ORDER_SUCCESS`) {
    return {
      ...state,
      loading: false,
      error: false,
      addedItems: action.value
    };
  }

  if (action.type === `RRP_ADD_MASTER_ORDER_ERROR`) {
    return {
      ...state,
      loading: false,
      error: true
    };
  }

  if (action.type === `RRP_REMOVE_MASTER_ORDER_LOADING`) {
    return {
      ...state,
      loading: true,
      error: false,
      addedItems: null,
      removedItems: null
    };
  }

  if (action.type === `RRP_REMOVE_MASTER_ORDER_SUCCESS`) {
    return {
      ...state,
      loading: false,
      error: false,
      removedItems: action.value
    };
  }

  if (action.type === `RRP_REMOVE_MASTER_ORDER_ERROR`) {
    return {
      ...state,
      loading: false,
      error: true
    };
  }

  if (action.type === `RRP_CANCEL_MASTER_ORDER_LOADING`) {
    return {
      ...state,
      loading: true,
      error: false
    };
  }

  if (action.type === `RRP_CANCEL_MASTER_ORDER_SUCCESS`) {
    return {
      ...state,
      rrpOrder: null,
      loading: false,
      error: false,
      addedItems: null,
      removedItems: null
    };
  }

  if (action.type === `RRP_CANCEL_MASTER_ORDER_ERROR`) {
    return {
      ...state,
      loading: false,
      error: true
    };
  }

  if (action.type === 'RRP_EXTEND_SESSION_LOADING') {
    return {
      ...state,
      loading: true,
      error: false,
      isExtended: null
    };
  }

  if (action.type === 'RRP_EXTEND_SESSION_ERROR') {
    return {
      ...state,
      loading: false,
      error: true,
      isExtended: null
    };
  }

  if (action.type === 'RRP_EXTEND_SESSION_SUCCESS') {
    return {
      ...state,
      loading: false,
      error: false,
      isExtended: true
    };
  }

  return state;
};

export default rrpCartReducer;
